import { Alert, Box, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useAgentValidationPanel } from './useAgentValidationPanel';

// TODO: cleanup with cp_annotation_createproject_agent ff

const HEADING_ID = 'agent-validation-heading';

/**
 * A success row per concept with saved special notes. It has no warnings and never blocks
 * Next, and it is not shown until at least one concept has notes.
 */
export const AgentValidationPanel = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const conceptsWithNotes = useAgentValidationPanel();

  if (conceptsWithNotes.length === 0) return null;

  return (
    <Box id="agent-validation-panel" component="section" aria-labelledby={HEADING_ID}>
      <Typography variant="subtitle1" id={HEADING_ID} sx={{ mb: theme.spacing(4) }}>
        {formatMessage({ id: 'createProjectWizard.step.annotationAgent.validation.title' })}
      </Typography>
      <Box
        component="ul"
        sx={{
          listStyle: 'none',
          m: 0,
          p: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(3),
        }}
      >
        {conceptsWithNotes.map(({ conceptGroupId, name }) => (
          <li key={conceptGroupId}>
            {/* A status, not an alert: these rows are confirmations and should not interrupt. */}
            <Alert severity="success" role="status">
              {formatMessage(
                { id: 'createProjectWizard.step.annotationAgent.validation.notesAdded' },
                { name, b: (chunks) => <strong>{chunks}</strong> }
              )}
            </Alert>
          </li>
        ))}
      </Box>
    </Box>
  );
};
